import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { adminActions } from 'features/feedback/store/admin.slice';
import TriageFilters from 'features/feedback/admin/TriageFilters';
import TriageTable from 'features/feedback/admin/TriageTable';
import TriageDetail from 'features/feedback/admin/TriageDetail';

const AdminTriagePage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { items, selectedId, loading, isAdmin, filters } = useAppSelector((s) => s.admin);

  useEffect(() => {
    if (isAdmin === null) dispatch(adminActions.checkAccess());
  }, [isAdmin, dispatch]);

  useEffect(() => {
    if (isAdmin) dispatch(adminActions.adminGet());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, filters.type, filters.status, filters.area]);

  if (isAdmin === null) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
  }
  if (isAdmin === false) {
    return <Box sx={{ textAlign: 'center', py: 8, color: '#7A7F88' }}>Доступ лише для адміністраторів.</Box>;
  }

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', width: '100%', p: 2 }}>
      <Box sx={{ border: '1px solid #E7E7E7', borderRadius: '18px', p: '22px', background: '#fff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Box sx={{ fontSize: 22, fontWeight: 800, flex: 1 }}>Тріаж звернень</Box>
          <Box sx={{ fontSize: 13, color: '#7A7F88' }}>{items.length} звернень</Box>
        </Box>
        <TriageFilters />
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
        ) : (
          <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
            {items.length === 0
              ? <Box sx={{ flex: 1, color: '#7A7F88', py: 4, textAlign: 'center' }}>Немає звернень за фільтром</Box>
              : <TriageTable items={items} selectedId={selectedId} onSelect={(id) => dispatch(adminActions.select(id))} />}
            <TriageDetail />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AdminTriagePage;
